/**
 *
 * HtmlContent
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

/* eslint-disable */
class HTMLContent extends React.PureComponent {
  contentClickHandler = e => {
    const targetLink = e.target.closest('a');
    const hasPathName = !_isEmpty(_get(e, 'target.pathname'));
    if(targetLink && hasPathName) {
      e.preventDefault();
      e.stopPropagation();
      this.props.history.push(e.target.pathname);
    }
  };

  render() {
    return (
      <span
        role="button"
        onClick={this.contentClickHandler}
        dangerouslySetInnerHTML={{ __html: this.props.content }}
      />
    );
  }
}

HTMLContent.propTypes = {
  content: PropTypes.any,
  history: PropTypes.object,
};

export default withRouter(HTMLContent);
